export default __webpack_public_path__ + "static/main-video01-3c5f100eb2747dd49f26d4bbd8421270.jpg";